<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-11 p-0">
    <!-- <app-header></app-header> -->
    <div class="row col-12 p-0 m-0">
      <div class="col-md-10 col-lg-11 pl-0 pr-0 pt-0 pb-5 col-height ">



        <div>
          <div class="padding-left-employees">
            <div class="breadcrumbs-section pl-0 ml-3 mb-4">
              <span class="prev-page pr-1"><a routerLink="/overview">Home</a></span>
              <span class="separator">></span>
              <span class="curr-page pl-1">Contact</span>
            </div>
            <div class="d-flex justify-content-between meetings-layout booking-heading">
              <p class="ml-3">Contact Details</p>
              <button *ngIf="showResult" class="edit-button btn" (click)="edit()" type="submit">Edit</button>
            </div>

            <form [formGroup]="contactForm" *ngIf="!showResult">
              <div class="d-flex justify-textbox col-12 row  mt-4">
                <div class="col-6">
                  <input type="tel" class="search-line  textbox-onselect pl-4 placeholder-text"
                    formControlName="mobilenumber" [(ngModel)]="contactNumber" min="1" step="1" maxlength="10"
                    minlength="10" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                  <label class="form-lable form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                  <div class="col-10 field-error pl-0 ml-0"> <span *ngIf="fieldErrors.includes('phone')">Please enter
                      valid
                      mobile number</span>
                  </div>
                </div>
                <div class="col-6">
                  <input type="text" class="search-line textbox-onselect  pl-4 placeholder-text" formControlName="email"
                    [(ngModel)]="emailId" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+.[a-zA-Z]{2,4}$">
                  <label class="form-lable form-lable-email" for="mobile-emailid">Email ID</label>
                  <div class="col-10 field-error pl-0 ml-0"> <span *ngIf="fieldErrors.includes('emailID')">Please enter
                      valid
                      Email</span>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-textbox col-12 row  mt-4">
                <div class="col-6">
                  <input type="text" class="search-line  textbox-onselect pl-4 placeholder-text"
                    formControlName="building" [(ngModel)]="buildingName">
                  <label class="form-lable form-lable-building" for="mobile-emailid">Building Name, Floor/ Plot
                    No.</label>
                  <div class="col-10 field-error pl-0 ml-0"> <span *ngIf="fieldErrors.includes('building')">This field
                      is Mandatory</span>
                  </div>
                </div>
                <div class="col-6">
                  <input type="text" class="search-line textbox-onselect  pl-4 placeholder-text" formControlName="area"
                    [(ngModel)]="areaName">
                  <label class="form-lable form-lable-area" for="mobile-emailid">Area/locality</label>
                  <div class="col-10 field-error pl-0 ml-0"> <span *ngIf="fieldErrors.includes('area')">This field is
                      Mandatory</span>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-textbox col-12 row  mt-4">
                <div class="col-6">
                  <input type="text" class="search-line  textbox-onselect pl-4 placeholder-text" formControlName="city"
                    [(ngModel)]="cityName">
                  <label class="form-lable form-lable-city" for="mobile-emailid">City</label>
                  <div class="col-10 field-error pl-0 ml-0"> <span *ngIf="fieldErrors.includes('city')">This field is
                      Mandatory</span>
                  </div>
                </div>
                <div class="col-6">
                  <input type="tel" class="search-line textbox-onselect  pl-4 placeholder-text"
                    formControlName="pincode" [(ngModel)]="pin" min="1" step="1" maxlength="6" minlength="6"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                  <label class="form-lable form-lable-pin" for="mobile-emailid">Pincode</label>
                  <div class="col-10 field-error pl-0 ml-0"> <span *ngIf="fieldErrors.includes('pincode')">Please enter
                      valid
                      Pincode</span>
                  </div>
                </div>
              </div>
              <div class="line pt-5"></div>
              <div class="d-flex pt-5 ml-4">
                <div>
                  <button class="cancel-button" (click)="cancel()">
                    <span class="cancel">Cancel</span>
                  </button>
                </div>

                <div class="pl-3">
                  <button class="add-button" type="submit" (click)="saveContact()">
                    <span class="add">Save</span>
                  </button>
                </div>
              </div>
            </form>


            <div *ngIf="showResult">
              <div class="row m-2 mb-4">
                <div class="col-5">
                  <span class="detailTitle">Mobile Number</span>
                  <span class="detailContent">+91 {{contactNumber}}</span>
                </div>
                <div class="col-7">
                  <span class="detailTitle">Email ID</span>
                  <span class="detailContent">{{emailId}}</span>
                </div>
              </div>
              <div class="row m-2 mb-4">
                <div class="col-5">
                  <span class="detailTitle">Building Name, Floor / Plot No.</span>
                  <span class="detailContent">{{buildingName}}</span>
                </div>
                <div class="col-7">
                  <span class="detailTitle">Area / Locality</span>
                  <span class="detailContent">{{areaName}}</span>
                </div>
              </div>
              <div class="row m-2 mb-4">
                <div class="col-5">
                  <span class="detailTitle">City</span>
                  <span class="detailContent">{{cityName}}</span>
                </div>
                <div class="col-7">
                  <span class="detailTitle">Pincode</span>
                  <span class="detailContent">{{pin}}</span>
                </div>
              </div>
            </div>



          </div>
        </div>
        <div class="col-12 row borders m-0 p-0 ">
        </div>
      </div>





    </div>
  </div>
</div>
